import React from 'react'
import {Redirect} from 'react-router-dom';
import store from 'utils/store'
const Lock=(props)=>{
  let check=typeof props.check ==="function" ? props.check() : props.check
  if(check){
    return props.children
  }else{
    store.dispatch({type:"ADD_TOAST", message:"You can't access this page."})
    return (
      <Redirect to={props.redirect}/>
    )
  }
}


export default Lock;



// WEBPACK FOOTER //
// ./src/components/lock/index.js